var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Suspense, lazy } from "react";
import { CircularProgress, Box } from "@mui/material";
import Footer from "../components/Footer";
import Menu from "../components/Menu";
import Offline from "../views/Offline";
// Lazy load components for code splitting
var Home = lazy(function () { return import("../views/Home"); });
var NotFound = lazy(function () { return import("../views/404"); });
var BeerList = lazy(function () { return import("../views/BeerList"); });
var Beer = lazy(function () { return import("../views/Beer"); });
// Loading fallback component
var LoadingFallback = function () { return (_jsxs(Box, __assign({ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "200px", flexDirection: "column", gap: 2 }, { children: [_jsx(CircularProgress, { size: 40 }), _jsx("span", { children: "Loading..." })] }))); };
var Router = function () { return (_jsx(BrowserRouter, { children: _jsxs(Menu, { children: [_jsx(Offline, {}), _jsx(Suspense, __assign({ fallback: _jsx(LoadingFallback, {}) }, { children: _jsxs(Routes, { children: [_jsx(Route, { index: true, element: _jsx(Home, {}) }), _jsxs(Route, __assign({ path: "beer" }, { children: [_jsx(Route, { index: true, element: _jsx(BeerList, {}) }), _jsx(Route, { path: ":id", element: _jsx(Beer, {}) })] })), _jsx(Route, { path: "*", element: _jsx(NotFound, {}) })] }) })), _jsx(Footer, {})] }) })); };
export default Router;
